export type HeaderProps = {
  showIconOnlyHeader?: boolean;
};

const Header: React.FC<HeaderProps> = () => (
  <cr-global-header simple='true'></cr-global-header>
);
export default Header;
